import get from 'lodash/get';
import patch from './patch';
import { computeTakeActionResults } from './computeResults';

/**
 * @param {String} vehicleType ui trade in key.
 * @param {Number} value Index of vehicle to trade in.
 */
export default (vehicleType, value) => (dispatch, getState) => {
  const state = getState();
  if (get(state.ui, `tradeInVehicleIndices.${vehicleType}`) === value) return;
  dispatch(patch({
    ui: {
      tradeInVehicleIndices: {
        [vehicleType]: value,
      },
    },
  }));
  computeTakeActionResults()(dispatch, getState);
};
